import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { queries as addressSelectQueries } from "domains/postGig/containers/AddressSelect/queries";
import { queries as directOfferHeaderQueries } from "domains/postGig/containers/DirectOfferHeader/queries";
import { queries as managerSelectQueries } from "domains/postGig/containers/ManagerSelect/queries";
import { queries as positionSelectQueries } from "domains/postGig/containers/PositionSelect/queries";
import { queries as shiftSelectQueries } from "domains/postGig/containers/ShiftSelect/queries";
import { queries as wagePickerQueries } from "domains/postGig/containers/WagePicker/queries";
import { queries as copySourceQueries } from "domains/postGig/hooks/queries";
import type { MarketplaceSearch } from "domains/schedule/utils/useMarketplaceSearch";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { location: ForManagerLocationDetail; search: MarketplaceSearch };

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  ...copySourceQueries(input),
  ...directOfferHeaderQueries(input),
  ...shiftSelectQueries(input),
  ...addressSelectQueries(input),
  ...positionSelectQueries(input),
  ...wagePickerQueries(input),
  ...managerSelectQueries(input),
];
